/**
 * NavCart — the cart that lives inside the nav panel
 *
 * The cart-drawer section renders the cart's markup hidden at the end of
 * <body> ([data-nav-cart] wrapping .nav-cart). This class mounts that markup
 * into the nav panel's cart accordion ([data-nav-cart-target], see
 * sections/header.liquid), handles quantity/remove clicks, and re-fetches the
 * section after every cart change so the accordion always shows live contents.
 */
class NavCart {
  constructor() {
    this.target = document.querySelector('[data-nav-cart-target]');
    if (!this.target) return;

    this.mount(document);

    document.addEventListener('click', this.handleClick.bind(this));
    document.addEventListener('archive:cart-updated', () => this.refresh());
  }

  // Move the section-rendered .nav-cart out of its hidden wrapper and into
  // the accordion body, replacing whatever was mounted before.
  mount(root) {
    const source = root.querySelector('[data-nav-cart]');
    const content = source?.querySelector('.nav-cart');
    if (!content) return;

    this.target.replaceChildren(content);
    source.remove();
  }

  handleClick(event) {
    const quantityTrigger = event.target.closest('[data-cart-quantity]');
    if (quantityTrigger && this.target.contains(quantityTrigger)) {
      event.preventDefault();
      this.updateLine(Number(quantityTrigger.dataset.line), Number(quantityTrigger.dataset.quantity));
      return;
    }

    const removeTrigger = event.target.closest('[data-cart-remove]');
    if (removeTrigger && this.target.contains(removeTrigger)) {
      event.preventDefault();
      this.updateLine(Number(removeTrigger.dataset.line), 0);
    }
  }

  async updateLine(line, quantity) {
    const root = window.Shopify?.routes?.root || '/';
    await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line, quantity: Math.max(0, quantity) })
    });

    await this.refresh();
  }

  async refresh() {
    const response = await fetch(`${window.location.pathname}?sections=cart-drawer`);
    const payload = await response.json();
    const wrapper = document.createElement('div');
    wrapper.innerHTML = payload['cart-drawer'];

    this.mount(wrapper);
    document.dispatchEvent(new CustomEvent('archive:cart-refresh-count'));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.ArchiveNavCart = new NavCart();
});
